export default [
  require("/workspace/frontend/docs-site/.docusaurus/docusaurus-plugin-css-cascade-layers/default/layers.css"),
  require("/workspace/frontend/docs-site/node_modules/infima/dist/css/default/default.css"),
  require("/workspace/frontend/docs-site/node_modules/@docusaurus/theme-classic/lib/prism-include-languages"),
  require("/workspace/frontend/docs-site/node_modules/@docusaurus/theme-classic/lib/nprogress"),
  require("/workspace/frontend/docs-site/src/css/custom.css"),
  require("/workspace/frontend/docs-site/node_modules/docusaurus-theme-openapi-docs/lib/theme/styles.scss"),
];
